// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"38fefbf6","453":"abcd6afd","732":"2f1e235f","977":"60726c6c"}[chunkId] + ".chunk.js";
};